var React = require('react');

function XKinni (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#0072ce;}")),React.createElement("g",{"id":"Layer_2","key":1},React.createElement("g",{"id":"Layer_1-2"},React.createElement("polygon",{"className":"cls-1","points":"21.21 1.41 19.8 0 10.61 9.19 1.41 0 0 1.41 9.19 10.61 0 19.8 1.41 21.21 10.61 12.02 19.8 21.21 21.21 19.8 12.02 10.61 21.21 1.41"})))]);
}

XKinni.defaultProps = {"viewBox":"0 0 21.21 21.21"};

module.exports = XKinni;

XKinni.default = XKinni;
